<span [ngStyle]="{display: visible ? '' : 'none'}" [ngClass]="{'no-rate-strike': showStrike===true}"
  >&nbsp;&nbsp;&nbsp;{{marketMid}}&nbsp;&nbsp;&nbsp;</span
>
